import { warn } from "@/lib/log";
export const LANGS = [
  { code: "auto", name: "Auto-detect", locale: "" },
  { code: "en", name: "English", locale: "en-US" },
  { code: "it", name: "Italiano", locale: "it-IT" },
  { code: "de", name: "Deutsch", locale: "de-DE" },
  { code: "fr", name: "Français", locale: "fr-FR" },
  { code: "es", name: "Español", locale: "es-ES" },
  { code: "pt", name: "Português", locale: "pt-PT" },
  { code: "nl", name: "Nederlands", locale: "nl-NL" },
  { code: "pl", name: "Polski", locale: "pl-PL" },
  { code: "ru", name: "Русский", locale: "ru-RU" },
  { code: "tr", name: "Türkçe", locale: "tr-TR" },
  { code: "ar", name: "العربية", locale: "ar-SA" },
  { code: "hi", name: "हिन्दी", locale: "hi-IN" },
  { code: "zh", name: "中文", locale: "zh-CN" },
  { code: "ja", name: "日本語", locale: "ja-JP" },
  { code: "ko", name: "한국어", locale: "ko-KR" },
];

export const langName = (c) => LANGS.find((l) => l.code === c)?.name || c;
export const langLocale = (c) => LANGS.find((l) => l.code === c)?.locale || navigator.language;
export const browserLang = () => {
  const c = (navigator.language || "en").slice(0, 2);
  return LANGS.some((l) => l.code === c) ? c : "en";
};

export const LOGO_URL = "/logo-mark.png";

export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "");
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString([], { dateStyle: "short", timeStyle: "short" }) : "—");

export const inviteLink = (roomId, lang) => {
  const { protocol, hostname, port } = window.location;
  return `${protocol}//${hostname.replace(/\.+$/, "")}${port ? `:${port}` : ""}/api/invite/${roomId}${lang ? `?lang=${lang}` : ""}`;
};

export const MAX_PARTICIPANTS = 4;

let beepCtx = null;
const tone = (freqs, gap = 0.11) => {
  try {
    beepCtx ||= new (window.AudioContext || window.webkitAudioContext)();
    if (beepCtx.state === "suspended") beepCtx.resume();
    freqs.forEach((f, i) => {
      const t = beepCtx.currentTime + i * gap;
      const o = beepCtx.createOscillator();
      const g = beepCtx.createGain();
      o.type = "sine";
      o.frequency.setValueAtTime(f, t);
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.09, t + 0.015);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.09);
      o.connect(g).connect(beepCtx.destination);
      o.start(t);
      o.stop(t + 0.1);
    });
  } catch (e) { warn("Beep unavailable", e); }
};

export const unlockBeep = () => {
  try {
    beepCtx ||= new (window.AudioContext || window.webkitAudioContext)();
    if (beepCtx.state === "suspended") beepCtx.resume();
  } catch (e) { warn("Beep unavailable", e); }
};

export const haptic = (pattern) => {
  try { navigator.vibrate?.(pattern); } catch (e) { warn("Vibration unavailable", e); }
  if (localStorage.getItem("aurora_beep") !== "off") tone(Array.isArray(pattern) ? [880, 587] : [660, 988]);
};
export const HAPTIC_START = 35;
export const HAPTIC_STOP = [20, 60, 20];
